/*
|--------------------------------------------------------------------------
| Lunelle Wellness
| Collection Hub
|--------------------------------------------------------------------------
|
| Main controller for the Collection Hub.
|
|--------------------------------------------------------------------------
*/

window.Lunelle = window.Lunelle || {};

Lunelle.ProductHub = class {

    constructor() {

        this.form =
            document.querySelector("#LwFilterForm");

        this.api =
            new Lunelle.ProductAPI({

                feedSelector: "#LwHubFeed"

            });

        this.bindGlobal();

        this.bindUI();

        this.updateVisibleCount();

    }

    /*
    |--------------------------------------------------------------------------
    | Global Events
    |--------------------------------------------------------------------------
    */

    bindGlobal() {

        window.addEventListener(
            "popstate",
            () => {

                this.api.load(
                    window.location.href,
                    false
                );

            }
        );

        document.addEventListener(
            "lunelle:collection:updated",
            () => {

                this.form =
                    document.querySelector("#LwFilterForm");

                this.bindUI();

                this.updateVisibleCount();

                /*
                |--------------------------------------------------------------------------
                | Re-initialize Shopify Components
                |--------------------------------------------------------------------------
                */

                document.dispatchEvent(
                    new CustomEvent(
                        "shopify:section:load"
                    )
                );


                if (
                    window.Shopify &&
                    Shopify.PaymentButton
                ) {

                    Shopify.PaymentButton.init();

                }

            }
        );

    }

    /*
    |--------------------------------------------------------------------------
    | Bind Current UI
    |--------------------------------------------------------------------------
    */

    bindUI() {

        this.bindFilters();

        this.bindQuickFilters();

        this.bindResetButton();

        this.bindSorting();

        this.bindPagination();

        this.bindToolbarLoadMore();

        this.bindMobileDrawer();

        this.highlightActiveQuickFilters();

        }

    /*
    |--------------------------------------------------------------------------
    | Sidebar Filters
    |--------------------------------------------------------------------------
    */

    bindFilters() {

        if (!this.form) {
            return;
        }

        if (this.form.dataset.bound === "true") {
            return;
        }

        this.form.dataset.bound = "true";

        this.form.addEventListener(
            "change",
            () => {

                this.updateFromForm();

            }
        );

        const debounce =
            Lunelle.Utils.debounce(
                () => this.updateFromForm(),
                500
            );

        this.form
            .querySelectorAll('input[type="number"]')
            .forEach(input => {

                input.addEventListener(
                    "input",
                    debounce
                );

            });

    }

    /*
    |--------------------------------------------------------------------------
    | Quick Filters
    |--------------------------------------------------------------------------
    */

    bindQuickFilters() {

        document
            .querySelectorAll("[data-ajax-filter-link]")
            .forEach(link => {

                if (link.dataset.bound === "true") {
                    return;
                }

                link.dataset.bound = "true";

                link.addEventListener(
                    "click", event => {

                        event.preventDefault();

                        if (
                            link.hasAttribute("data-reset-filters") &&
                            this.form
                        ) {

                            this.form.reset();

                        }

                        this.closeMobileDrawer();

                        this.api.load(
                            link.href
                        );

                    }
                );

            });

    }

    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    bindPagination() {

        const button =
            document.querySelector("#LwLoadMore a");

        if (!button) {
            return;
        }

        if (button.dataset.bound === "true") {
            return;
        }

        button.dataset.bound = "true";

        button.addEventListener(
            "click",
            event => {

                event.preventDefault();

                this.api.append(button.href);

            }
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Load More
    |--------------------------------------------------------------------------
    */
    bindToolbarLoadMore(){

        const button =
            document.querySelector("[data-load-more-toolbar]");

        if(!button){
            return;
        }

        if(button.dataset.bound === "true"){
            return;
        }

        button.dataset.bound = "true";

        button.addEventListener(
            "click",
            event => {

                event.preventDefault();

                this.api.append(
                    button.href,
                    {
                        scrollToNewProducts: false
                    }
                );

            }
        );

    }

    /*
    |--------------------------------------------------------------------------
    | Mobile Filter Drawer
    |--------------------------------------------------------------------------
    */

    bindMobileDrawer() {

        const sidebar =
            document.querySelector("#LwHubSidebar");

        const backdrop =
            document.querySelector(".lw-sidebar-backdrop");

        const openButtons =
            document.querySelectorAll(
                "[data-open-filters]"
            );

        const closeButtons =
            document.querySelectorAll(
                "[data-close-filters]"
            );


        if (!sidebar) {
            return;
        }


        openButtons.forEach(button => {

            if (button.dataset.bound === "true") {
                return;
            }

            button.dataset.bound = "true";

            button.addEventListener(
                "click",
                () => {

                    sidebar.classList.add(
                        "is-open"
                    );

                    if (backdrop) {

                        backdrop.classList.add(
                            "is-active"
                        );

                    }

                    document.body.classList.add(
                        "lw-filter-open"
                    );

                }
            );

        });


        closeButtons.forEach(button => {

            if (button.dataset.bound === "true") {
                return;
            }

            button.dataset.bound = "true";

            button.addEventListener(
                "click",
                () => {

                    sidebar.classList.remove(
                        "is-open"
                    );

                    if (backdrop) {

                        backdrop.classList.remove(
                            "is-active"
                        );

                    }

                    document.body.classList.remove(
                        "lw-filter-open"
                    );

                }
            );

        });

    }

    /*
    |--------------------------------------------------------------------------
    | Close Mobile Drawer
    |--------------------------------------------------------------------------
    */

    closeMobileDrawer(){

        const sidebar =
            document.querySelector("#LwHubSidebar");

        const backdrop =
            document.querySelector(".lw-sidebar-backdrop");


        if(sidebar){

            sidebar.classList.remove("is-open");

        }


        if(backdrop){

            backdrop.classList.remove("is-active");

        }


        document.body.classList.remove(
            "lw-filter-open"
        );

    }

    /*
    |--------------------------------------------------------------------------
    | Sorting
    |--------------------------------------------------------------------------
    */

    bindSorting() {

        document
            .querySelectorAll("[data-sort-by]")
            .forEach(select => {

                if (select.dataset.bound === "true") {
                    return;
                }

                select.dataset.bound = "true";

                select.addEventListener(
                    "change",
                    () => {

                        const url =
                            new URL(
                                window.location.href
                            );

                        url.searchParams.set(
                            "sort_by",
                            select.value
                        );

                        this.api.load(
                            url.toString()
                        );

                    }
                );

            });

    }

    /*
|--------------------------------------------------------------------------
| Reset Filters
|--------------------------------------------------------------------------
*/

bindResetButton(){

    const button =
        document.querySelector("#LwResetFiltersBtn");

    if(!button){
        return;
    }

    if(button.dataset.bound === "true"){
        return;
    }

    button.dataset.bound = "true";

    button.addEventListener(
        "click",
        () => {

            if(this.form){
                this.form.reset();
            }

            this.closeMobileDrawer();

            this.api.load(
                window.location.pathname
            );

        }
    );

}

    /*
    |--------------------------------------------------------------------------
    | Form Serialization
    |--------------------------------------------------------------------------
    */

    updateFromForm() {

        const params =
            Lunelle.Utils.serializeForm(
                this.form
            );

        const url =
            new URL(
                this.form.action,
                window.location.origin
            );

        url.search =
            params.toString();

        this.closeMobileDrawer();

        this.api.load(
            url.toString()
        );

    }

    /*
    |--------------------------------------------------------------------------
    | Update Product Count
    |--------------------------------------------------------------------------
    */

    updateVisibleCount(){

        const visible =
            document.querySelectorAll(
                "#product-grid .grid__item"
            ).length;

        const count =
            document.querySelector(
                "#LwVisibleCount"
            );

        if(count){

            count.textContent = visible;

        }

    }

    /*
    |--------------------------------------------------------------------------
    | Active Quick Filter
    |--------------------------------------------------------------------------
    */

    highlightActiveQuickFilters(){

    const currentPath =
        window.location.pathname;

    document
        .querySelectorAll("[data-ajax-filter-link]")
        .forEach(chip => {

            const chipURL =
                new URL(
                    chip.href,
                    window.location.origin
                );

            chip.classList.toggle(
                "is-active",
                chipURL.pathname === currentPath
            );

        });

}

};

/*
|--------------------------------------------------------------------------
| Initialise
|--------------------------------------------------------------------------
*/

document.addEventListener(
    "DOMContentLoaded",
    () => {

        new Lunelle.ProductHub();

    }
);